import { ThemeConfig } from 'antd'

const defaultTheme: ThemeConfig = {
  token: {
    colorPrimary: '#0061B5',
    borderRadius: 2,
    fontSize: 13,
    fontFamily: `"Rubik", sans-serif`,
  },
  components: {
    Button: {
      controlOutlineWidth: 1,
    },
    FloatButton: {
      colorBgElevated: '#d2d9e5',
      colorText: '#fff',
      borderRadiusLG: 5,
      controlHeightLG: 40,
      fontSizeIcon: 16,
    },
    Tag: {
      controlHeightSM: 16,
      paddingXS: 4,
      paddingXXS: 8,
      fontSizeSM: 11,
      fontWeightStrong: 700,
      borderRadiusSM: 4,
    },
    Menu: {
      itemMarginInline: 0,
      activeBarBorderWidth: 3,
      activeBarWidth: 3,
    },
    Table: {
      rowHoverBg: 'none !important'
    },
    Input: {
      controlHeight: 56,
      borderRadius: 4,
      colorBorder: '#B2B2B2',
      paddingInline: 16,
      fontSize: 14,
      fontWeightStrong: 400,
      lineHeight: 1.2,
    },
    InputNumber: {
      controlHeight: 56,
      borderRadius: 4,
      colorBorder: '#B2B2B2',
      paddingInline: 16,
      fontSize: 14,
      fontWeightStrong: 400,
      lineHeight: 1.2,
    },
    Select: {
      controlHeight: 56,
      borderRadius: 4,
      colorBorder: '#B2B2B2',
      fontSize: 14,
      fontWeightStrong: 400,
      lineHeight: 1.2,
    },
    DatePicker: {
      controlHeight: 56,
      borderRadius: 4,
      colorBorder: '#B2B2B2',
      paddingInline: 16,
      fontSize: 14,
      fontWeightStrong: 400,
      lineHeight: 1.2,
    },
  },
}

export default defaultTheme
